import { SetValidationRuleFunction } from "features/shared/forms/hooks/useForm";
import { getFileExtensionValidationMessage, getMultipleFilesValidationMessage } from "features/shared/helpers/translationHelper";
import FilesValidationRule from "features/validation/rules/FilesValidationRule";
import FunctionValidationRule from "features/validation/rules/FunctionValidationRule";
import ValidationService from "features/validation/ValidationService";
import { TFunction } from "i18next";

export const setFileValidation = (setValidationRule: SetValidationRuleFunction, t: TFunction) => {
  const rule: FilesValidationRule = {
    message: `${getMultipleFilesValidationMessage(t)} ${getFileExtensionValidationMessage(t)}`,
    type: "Files",
    filesCount: 5
  };

  setValidationRule("files", rule);
}

export const setDocumentsTypeValidation = (setValidationRule: SetValidationRuleFunction, fileInputRef: React.RefObject<HTMLInputElement>) => {
  const validateDocumentTypes = (value: any) => {
    let files = fileInputRef.current?.files;
    let validationService = new ValidationService();

    if (files && files.length > 0) {
      return validationService.validateReuired(value);
    }

    return true;
  }

  const rule: FunctionValidationRule = {
    type: "Function",
    message: "basicInfoValidation.documentsType",
    validate: validateDocumentTypes
  };

  setValidationRule("documentsType", rule);
}